module.exports = __webpack_public_path__ + "img/Boxenstop.40e046b4.jpg";